import React, { forwardRef } from 'react';

import { PasteIcon } from 'src/components/icons/PasteIcon';
import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql/hooks/user';
import { useDocumentParams } from 'src/helpers';
import { useEditor } from 'src/layout-engine';
import { editorHotkeys, handlePaste } from 'src/layout-engine/components/KeyboardInputHandler';

/**
 * @deprecated Once the context menu is using DeclarativeMenu, remove this and refactor out the
 * relevant menu item configs from useEditMenu instead.
 */
export const PasteMenuItem = forwardRef(function PasteMenuItem(
  props: CommonMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { closeRootMenu, ...rest } = props;

  const editor = useEditor();
  const { documentId } = useDocumentParams();
  const currentUserId = useCurrentUserId();
  const editingMode = useEditorTabStateSelector(state => state.documentUi.editingMode);

  async function paste(): Promise<void> {
    closeRootMenu();
    if (!currentUserId || !editingMode) return;
    await handlePaste(editor, { authorId: currentUserId, documentId, editingMode });
    ClientTransforms.focus(editor);
  }

  return (
    <BaseMenuOption
      ref={ref}
      icon={<PasteIcon />}
      label="Paste"
      shortCutKey={editorHotkeys.paste.hint}
      onClick={paste}
      {...rest}
    />
  );
});
